import { Component, Input } from '@angular/core';
import { ActivityMetricsV2Breakdown, ActivityMetricsV2BreakdownRow } from '../../../../shared/models/activity-metrics-v2.model';

@Component({
  selector: 'app-agent-performance-activity-metrics-breakdown-groups-widget',
  templateUrl: './agent-performance-activity-metrics-breakdown-groups-widget.component.html',
  styleUrls: ['./agent-performance-activity-metrics-breakdown-groups-widget.component.scss']
})
export class AgentPerformanceActivityMetricsBreakdownGroupsWidgetComponent {
  @Input() breakdowns: ActivityMetricsV2Breakdown[] = [];
  @Input() widget_title = 'Breakdown Groups';

  get groupedBreakdowns(): Array<{ key: string; label: string; breakdowns: ActivityMetricsV2Breakdown[] }> {
    const families = [
      { key: 'outcomes', label: 'Outcomes', matchers: ['resolution_outcome', 'resolution_result', 'resolution_score'] },
      { key: 'lifecycle', label: 'Lifecycle', matchers: ['attempt_lifecycle', 'subject_lifecycle'] },
      { key: 'service', label: 'Service', matchers: ['service_type'] },
      { key: 'region', label: 'Region', matchers: ['state', 'postcode', 'suburb_region'] },
      { key: 'combined', label: 'Combined', matchers: ['_x_'] }
    ];

    const mapped = families
      .map((family) => ({
        key: family.key,
        label: family.label,
        breakdowns: this.breakdowns.filter((breakdown) =>
          family.matchers.some((matcher) => breakdown.breakdown_key.includes(matcher))
        )
      }))
      .filter((family) => family.breakdowns.length);

    const assignedKeys = new Set(mapped.flatMap((family) => family.breakdowns.map((breakdown) => breakdown.breakdown_key)));
    const remaining = this.breakdowns.filter((breakdown) => !assignedKeys.has(breakdown.breakdown_key));

    if (remaining.length) {
      mapped.push({
        key: 'other',
        label: 'Other',
        breakdowns: remaining
      });
    }

    return mapped;
  }

  getTopRows(breakdown: ActivityMetricsV2Breakdown, count = 10): ActivityMetricsV2BreakdownRow[] {
    return [...(breakdown.rows || [])]
      .sort((left, right) => (right.count ?? 0) - (left.count ?? 0))
      .slice(0, count);
  }

  formatPercent(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '-';
    }

    return `${value.toFixed(1)}%`;
  }

  trackByFamily(index: number, item: { key: string }): string {
    return `${index}:${item.key}`;
  }

  trackByBreakdown(index: number, item: ActivityMetricsV2Breakdown): string {
    return `${index}:${item.breakdown_key}`;
  }

  trackByRow(index: number, item: ActivityMetricsV2BreakdownRow): string {
    return `${index}:${item.row_key}`;
  }
}
